import './App.css';
import MainRoute from './pages/mainRoute.js';
import "./assets/css/design/support/feature.css";
import "./assets/css/design/support/support.css";

function App() {
  return(
    <MainRoute />
  )
}
export default App;